/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object'){
  /*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
general: {
  limit: boostPFSThemeConfig.custom.products_per_page,
  /* Optional */
  loadProductFirst: true,
  // Placeholder
  products_per_page: boostPFSThemeConfig.custom.products_per_page,
  showPlaceholderProductList: true,
  placeholderProductPerRow: 3,
  placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
  enableOTP: true,
  aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
  cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
  defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
  selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
},
selector: {
  otpButtons: '.boost-pfs-filter-product-item-image',
}
};

(function() {
var onSale = false,
  soldOut = false,
  priceVaries = false,
  images = [],
  firstVariant = {},
  boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

BoostPFS.inject(this);
boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0 && boostPFSThemeConfig.custom.filter_tree_horizontal_style != 'style-expand') ? true : false;
Selector.stickyElementDesktop = jQ('.boost-pfs-filter-tree-v').length > 0 && !Utils.isMobile() ?  '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  if (data.tags.includes('badge:sale') || data.tags.includes('badge:clearance')) {
    onSale = true;
  }
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  firstVariant = data['variants'][0];
  if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == Utils.getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
ProductGridItem.prototype.compileTemplate = function(data) {
  if (!data) data = this.data;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);

  // Get Template
  var itemHtml = boostPFSTemplate.productGridItemHtml;
  // Add Custom class
  var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
  var saleClass = onSale ? boostPFSTemplate.saleClass : '';

  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  itemHtml = itemHtml.replace(/{{itemSku}}/g, buildSku(data));
  itemHtml = itemHtml.replace(/{{itemPersonalize}}/g, buildPersonalize(data));
  // Add Review
  if (typeof Integration === 'undefined' ||
    (typeof Integration != 'undefined' &&
      typeof Integration.hascompileTemplate == 'function' &&
      !Integration.hascompileTemplate('reviews'))) {
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
  }

  // itemActiveSwapClass
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

  // Add Color Swatches
  itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
  return itemHtml;
};
// Build Product List Item
ProductListItem.prototype.compileTemplate = function(data) {
  if (!data) data = this.data;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);

  // For List View
  // Get Template
  var itemHtml = boostPFSTemplate.productListItemHtml;

  // Add Custom class
  var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
  var saleClass = onSale ? boostPFSTemplate.saleClass : '';

  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

  // Add Review
  if (typeof Integration === 'undefined' ||
    (typeof Integration != 'undefined' &&
      typeof Integration.hascompileTemplate == 'function' &&
      !Integration.hascompileTemplate('reviews'))) {
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
  }

  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  itemHtml = itemHtml.replace(/{{itemSku}}/g, buildSku(data));
  // Description
  var itemDescription = "";
  if (data.body_html != null){
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
  }
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

  // itemActiveSwapClass
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

  // Add Color Swatches
  itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

  return itemHtml;
  // End For List View
};

/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (boostPFSThemeConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'boost-pfs-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'boost-pfs-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'boost-pfs-filter-grid-width-5';
      break;
    case 6:
      gridWidthClass = 'boost-pfs-filter-grid-width-6';
      break;
    default:
      gridWidthClass = 'boost-pfs-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (boostPFSThemeConfig.custom.products_per_row_m) {
    case 1:
      gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '',
    aspectRatio = '',
    rangeWidths = boostPFSRangeWidths,
    paddingTop = 100;

  var dataSrcSet = '',
    dataWidths = '',
    dataSizes = 'auto',
    imgAlt = data.title,
    flipImageSrcSet = '';

  // var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
  //   boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
  //   boostPFSThemeConfig.custom.active_image_swap == true;
  // manually setting activeSwapImage to true
  var activeSwapImage = !Utils.isMobile() && images.length > 1;

  for (var i = 0; i < rangeWidths.length; i++) {
    dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
    dataWidths += rangeWidths[i];

    if (activeSwapImage) {
      flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
    }

    if (i < rangeWidths.length - 1) {
      dataSrcSet += ', ';
      dataWidths += ', ';

      if (activeSwapImage) {
        flipImageSrcSet += ', ';
      }
    }
  }

  if (images.length > 0) {
    aspectRatio = images[0]['width'] / images[0]['height'];
    paddingTop = 1 / aspectRatio * 100;
  }

  // hover toggle to secondary image
  var toggleImages = '';
  if (images.length > 1) {
    toggleImages = 'hover-toggle';
  }

  html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link '+ toggleImages +'" ';
  html += 'style="padding-top:' + paddingTop + '%;">';
  html += '<div class="boost-pfs-filter-product-image-wrapper">';
  html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
    'data-srcset="' + dataSrcSet + '" ' +
    'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
    'data-widths="[' + dataWidths + ']" ' +
    'data-sizes="' + dataSizes + '" ' +
    'src="' + boostPFSImgDefaultSrc + '" ' +
    'alt="' + imgAlt + '"  ';

  if (activeSwapImage) {
    html += ' data-img-flip-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x') + '" ' +
      'data-img-flip-srcset="' + flipImageSrcSet + '" ';
  }
  html += '/>';
  // create secondary image
  if (images.length > 1) {
    html += '<img class="boost-pfs-filter-product-item-secondary-image lazyload Image--lazyLoad"' +
      'data-srcset="' + flipImageSrcSet + '" ' +
      'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
      'data-widths="[' + dataWidths + ']" ' +
      'data-sizes="' + dataSizes + '" ' +
      'src="' + images[1].src + '" ' +
      'alt="' + images[1].alt + '"  ';
    html += '/>';
  }

  html += '</div></a>';

  return html;
}

function buildSku(data) {
  const product = data;
  var root_sku = '';
  if (product.metafields.length > 0) {
    const metafields = product.metafields;
    for(var i = 0; i < metafields.length; i++) {
      if (metafields[i].key == 'root_sku') {
        root_sku = metafields[i].value;
        break;
      }
    }
  }
  var sku_html = '';
  if (root_sku) {
    sku_html =
      '<div class="boost-pfs-filter-product-item-sku">' +
        '<p class="boost-pfs-filter-product-item-sku-inner">#' + root_sku + '</p>' +
      '</div>';
  }
  return sku_html;
}

function buildPersonalize(data) {
  const product = data;
  var icon_personalize = `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="28px" height="20px" viewBox="0 0 28 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Personalize</title>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-508.000000, -2396.000000)" fill="#2D3D0F">
                <g transform="translate(508.000000, 2396.000000)">
                    <g transform="translate(8.110721, 2.151611)">
                        <path d="M5.03881306,9.11545726 C4.91057482,9.09824509 4.79480704,9.03197205 4.71642783,8.93127466 C4.63806002,8.83143876 4.6042188,8.70578901 4.62203081,8.58099414 C4.63984053,8.45705856 4.70752296,8.34431573 4.81171625,8.26856631 C5.05038756,8.09471277 5.31844537,7.96045693 5.60519747,7.87437403 C5.87770087,7.7926118 6.16267474,7.75215922 6.4476486,7.75299418 C6.60349282,7.7538822 6.75845249,7.76420907 6.91252076,7.78658578 C7.06569535,7.80724171 7.21796714,7.83908599 7.36847894,7.87953857 C7.66592325,7.96044151 7.95534271,8.07318874 8.22784611,8.21518918 C8.4994604,8.35547765 8.75504776,8.52157997 8.99194083,8.71093151 C9.22347639,8.89511411 9.43453943,9.10166461 9.62155068,9.32889086 C9.77472299,9.51651501 9.91185925,9.71446823 10.0320954,9.92274612 C10.146085,10.1206993 10.2431539,10.3272498 10.3197366,10.5415647 C10.466676,10.9503869 10.5414828,11.3815726 10.540607,11.8144768 C10.540607,12.0141508 10.5263427,12.2129655 10.4969539,12.4091914 C10.4675651,12.6071446 10.4266018,12.8042429 10.3722767,12.9978909 C10.3179538,13.1941212 10.2520542,13.3877647 10.176356,13.5771163 C10.0988796,13.7707664 10.0116047,13.9609751 9.91632308,14.1468674 C9.80322494,14.3654766 9.66876059,14.5737567 9.5138032,14.7665453 C9.35617618,14.9644986 9.18252679,15.1486856 8.99462642,15.3190887 C8.80048855,15.4938038 8.5947739,15.6547393 8.37837615,15.802779 C8.15574089,15.9525351 7.9241962,16.0893842 7.68374666,16.2124605 C7.19395638,16.4629095 6.67386769,16.6574168 6.13597382,16.7908265 C5.86524866,16.8588182 5.59096701,16.9104591 5.31399522,16.9457449 C5.03882446,16.9818923 4.76096354,16.9991066 4.48223631,17.0000315 C4.24089764,17.0008274 3.99866986,16.9853338 3.75822032,16.9560718 C3.51954901,16.9268098 3.28356785,16.8803334 3.05200949,16.8183656 C2.82045113,16.7563978 2.59427308,16.6754948 2.37609709,16.57825 C2.15613374,16.4792734 1.94507982,16.3622231 1.74737635,16.2270882 C1.54433362,16.0885205 1.35643781,15.9318902 1.18454158,15.7597464 C1.00643292,15.5790075 0.847018538,15.3827839 0.708999997,15.1727654 C0.561169236,14.9489983 0.436496591,14.7131792 0.335866621,14.4687452 C0.127480055,13.9626694 0.00547932526,13.4281931 0.00101093511,13.3576214 C-0.013237758,13.0968389 0.124796741,12.9462213 0.310036591,13.0211115 C0.310036591,13.0211115 0.664475681,13.1071768 1.02691684,13.1398825 C1.12042474,13.1484886 1.21304125,13.1519324 1.30655599,13.1476293 C1.38047137,13.1450471 1.45438675,13.1381618 1.52741073,13.1261119 C1.5835141,13.1175058 1.64050888,13.1037352 1.69394262,13.0865208 C1.75449842,13.0667264 1.81149319,13.0417674 1.86670745,13.0116439 C1.91568648,12.9849642 1.96110447,12.9522584 2.00207003,12.9161111 C2.04659663,12.8782429 2.08578168,12.8360696 2.12051201,12.7895932 C2.16325809,12.7310692 2.20155174,12.6690992 2.23272104,12.6045513 C2.25142216,12.5658217 2.26745137,12.5253691 2.27902815,12.4840573 C2.29238545,12.4358601 2.30307311,12.3876629 2.31197797,12.3386043 C2.32088283,12.2800802 2.32800718,12.221554 2.33335101,12.1621685 C2.33958396,12.0933154 2.34492779,12.0236008 2.34938022,11.9547477 C2.35828508,11.8170415 2.37075326,11.6793353 2.38589335,11.5433476 C2.40637499,11.3781002 2.43843569,11.2154306 2.48118177,11.0553609 C2.53105219,10.8685961 2.59962375,10.686132 2.68422451,10.5114104 C2.78396536,10.3065719 2.90329873,10.1120624 3.03955271,9.92788862 C3.11524861,9.82632974 3.23012955,9.75747664 3.35835867,9.73682071 C3.48659691,9.71702627 3.61839162,9.74714977 3.72260086,9.82030592 C3.82857466,9.89346206 3.89981813,10.0044885 3.92030205,10.1284153 C3.94167509,10.2523509 3.91050579,10.3788643 3.83480989,10.4812957 C3.73328852,10.6172811 3.64512445,10.7618638 3.57122047,10.9133407 C3.51155378,11.0364148 3.46435527,11.1629304 3.42873354,11.2946216 C3.39667512,11.4116719 3.37441068,11.5304407 3.35927059,11.6509392 C3.3450219,11.7714332 3.33433424,11.891936 3.32720989,12.0132717 C3.32186606,12.0898716 3.31652451,12.1673308 3.30940016,12.2430758 C3.30227582,12.3239788 3.29247956,12.4048817 3.27912226,12.484932 C3.26487357,12.5709973 3.24706384,12.6562033 3.22212749,12.7396775 C3.19541062,12.830048 3.16157168,12.9186955 3.12060612,13.0038971 C3.06361135,13.1226682 2.9950398,13.2371384 2.91489147,13.3438662 C2.83919557,13.4437021 2.75370341,13.5366549 2.65841499,13.6201379 C2.56490709,13.7010408 2.46338572,13.7724762 2.35385773,13.832721 C2.2425401,13.8946888 2.12498952,13.9454682 2.00208599,13.9850593 C1.90056462,14.0177651 1.79726046,14.0418626 1.69039298,14.059077 C1.61469708,14.0719883 1.5096124,14.0866182 1.37781085,14.1021096 C1.30478687,14.1107157 1.27005426,14.1701012 1.30122356,14.2355128 C1.38137189,14.4059247 1.45885058,14.5479406 1.53542648,14.6632613 C1.63872836,14.8216234 1.75895313,14.9696521 1.89253292,15.1047804 C2.02077116,15.2338805 2.16059073,15.3500737 2.31196885,15.4533424 C2.46158013,15.5557605 2.6209945,15.6444103 2.78751043,15.7192806 C2.95760335,15.795019 3.13392466,15.8578483 3.31471208,15.9060455 C3.49994509,15.9559634 3.69051281,15.9938337 3.88288156,16.0170719 C4.08058275,16.0411716 4.28095585,16.0540807 4.48132667,16.0532192 C4.71641871,16.05236 4.95153354,16.0377278 5.18484734,16.0076043 C5.42262953,15.9766215 5.65861069,15.9318659 5.89105817,15.8742012 C6.35504121,15.7588717 6.80297453,15.5910331 7.22598973,15.3750217 C7.43081526,15.2708805 7.62673137,15.1546918 7.81552085,15.0264597 C7.99541003,14.9059657 8.16551435,14.7717143 8.32580645,14.6271117 C8.47541773,14.4928471 8.61344767,14.3456843 8.73812943,14.1881705 C8.85389949,14.043579 8.95542086,13.888654 9.03913022,13.7251251 C9.12106135,13.5659015 9.19586584,13.4015045 9.26265688,13.2353978 C9.3258846,13.0770356 9.38109885,12.9160956 9.42651685,12.7517075 C9.47015433,12.5959276 9.50399326,12.4375611 9.5271491,12.2774914 C9.54941126,12.1234323 9.56099031,11.9685227 9.56099031,11.8127274 C9.56187943,11.486529 9.50577606,11.1620711 9.39534983,10.8522211 C9.33568314,10.6904152 9.26355056,10.5337783 9.1762756,10.38402 C9.08187858,10.2204934 8.97412198,10.0638586 8.85389037,9.91753752 C8.71051204,9.741961 8.54753207,9.58274619 8.36854569,9.44072152 C8.18153216,9.29096547 7.97938538,9.16015339 7.76565499,9.04998843 C7.5554879,8.93982346 7.33285948,8.85375598 7.10310216,8.7909245 C6.99445644,8.76080099 6.88313881,8.73842428 6.77093662,8.72293289 C6.66318003,8.70744149 6.55453431,8.70055618 6.44499492,8.69969469 C6.25887051,8.6988354 6.07363978,8.72551515 5.89551972,8.77801537 C5.71741106,8.83223636 5.55088373,8.91572157 5.40215017,9.02416796 C5.29886425,9.09996586 5.16796321,9.13267164 5.03881306,9.11545726 Z" ></path>
                        <path d="M10.3107839,7.38893873 C10.2199479,7.47844776 10.095273,7.52836571 9.96436968,7.52836571 C9.83524004,7.52836571 9.71056056,7.47844776 9.61795545,7.38893873 C9.52711946,7.30115047 9.47457712,7.18065865 9.47457712,7.05500669 C9.47457712,6.92935474 9.52711946,6.8088541 9.61795545,6.72021537 L16.4545924,0.112961501 C16.611328,-0.0376538338 16.8651371,-0.0376538338 17.0218727,0.112961501 L18.8831168,1.91261635 C19.0389611,2.06323168 19.0389611,2.30938648 18.8831168,2.46000402 L12.0366768,9.07673207 C11.9440603,9.16537962 11.8193831,9.21529977 11.6893735,9.21529977 C11.5602438,9.21529977 11.4355643,9.16538182 11.3438483,9.07673207 C11.2512318,8.98808453 11.1995809,8.8675905 11.1995809,8.74194075 C11.1995809,8.616291 11.2512318,8.49578815 11.3438483,8.40714942 L17.4974599,2.46000402 C17.6533042,2.30938869 17.6533042,2.06323389 17.4974599,1.91261635 L17.0219183,1.45217087 C16.8651827,1.30155553 16.6113736,1.30155553 16.454638,1.45217087 L10.3107839,7.38893873 Z" ></path>
                    </g>
                    <g transform="translate(0.000000, 0.000000)">
                        <path d="M2.47404452,1.78643161 C2.7468143,1.78643161 2.97367637,1.97889181 3.02072263,2.23269334 L3.02967458,2.3304882 L3.02967458,5.96830904 C3.02967458,6.2687832 2.78091052,6.51236563 2.47404452,6.51236563 C2.20127473,6.51236563 1.97441267,6.31990544 1.9273664,6.0661039 L1.91841446,5.96830904 L1.91841446,2.3304882 C1.91841446,2.03001404 2.16717851,1.78643161 2.47404452,1.78643161 Z" fill-rule="nonzero"></path>
                        <path d="M4.2662091,3.60534204 C4.57307511,3.60534204 4.82183916,3.84892447 4.82183916,4.14939862 C4.82183916,4.41648676 4.62528485,4.63862341 4.36608431,4.68468972 L4.2662091,4.6934552 L0.555630059,4.6934552 C0.248764051,4.6934552 0,4.44987277 0,4.14939862 C0,3.88231048 0.196554312,3.66017383 0.455754853,3.61410752 L0.555630059,3.60534204 L4.2662091,3.60534204 Z" fill-rule="nonzero"></path>
                        <path d="M9.58530463,5.49133694 C9.85807442,5.49133694 10.0849365,5.68379714 10.1319827,5.93759867 L10.1409347,6.03539353 L10.1409347,9.67321437 C10.1409347,9.97368853 9.89217064,10.217271 9.58530463,10.217271 C9.31253485,10.217271 9.08567278,10.0248108 9.03862652,9.77100923 L9.02967458,9.67321437 L9.02967458,6.03539353 C9.02967458,5.73491937 9.27843863,5.49133694 9.58530463,5.49133694 Z" fill-rule="nonzero"></path>
                        <ellipse cx="4.10938012" cy="11.3524527" rx="1.11126012" ry="1.08811317"></ellipse>
                        <ellipse cx="7.99946107" cy="1.08811317" rx="1.11126012" ry="1.08811317"></ellipse>
                        <path d="M11.3774692,7.31024737 C11.6843352,7.31024737 11.9330993,7.5538298 11.9330993,7.85430395 C11.9330993,8.12139209 11.736545,8.34352874 11.4773444,8.38959505 L11.3774692,8.39836053 L7.66689018,8.39836053 C7.36002417,8.39836053 7.11126012,8.1547781 7.11126012,7.85430395 C7.11126012,7.58721581 7.30781443,7.36507916 7.56701497,7.31901285 L7.66689018,7.31024737 L11.3774692,7.31024737 Z" fill-rule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  `;
  var personalize_html = '';
  if (product.tags.includes('personalization:true')) {
    personalize_html = `
        <div class="mt-3 flex gap-2 items-center">
          ${icon_personalize}
          <span class="font-brandon uppercase font-bold text-[10px] leading-4 tracking-1/5px text-grey-1">Personalize it</span>
        </div>
      `;
  }
  return personalize_html;
}

function buildPrice(data) {
    const product = data;
    const variants = product.variants;
    const options = product.options;
    const current_variant = product.variants[0];
    var price_html = '';
    var is_sale = false;
    if (current_variant.compare_at_price) {
      if (parseFloat(current_variant.compare_at_price) > parseFloat(current_variant.price)) {
        is_sale = true;
      }
    }
    if (is_sale) {
      price_html = `
      <p class="boost-pfs-filter-product-item-price-inner">
        <span class="boost-pfs-filter-product-item-sale-price">
          <span class="sr-only"> On sale from </span>
          ${Utils.formatMoney(current_variant.price)}
        </span>
        <s class="boost-pfs-filter-item-compare-price">
          <span class="sr-only">Regular price</span>
          ${Utils.formatMoney(current_variant.compare_at_price)}
        </s>
      </p>
      `;
    } else {
      if (product.price_min != product.price_max) {
        price_html = `<span class="boost-pfs-filter-product-item-price-from">
          <span class="sr-only">Price from</span>
          ${Utils.formatMoney(product.price_min)}-
        </span>`;
      }
      price_html += `<span class="boost-pfs-filter-product-item-price-to">
        <span class="sr-only">${product.price_min != product.price_max ? 'to' : 'Regular Price'}</span>
        ${Utils.formatMoney(product.price_max)}
      </span>`;
    }
    price_html = `<div class="boost-pfs-filter-product-item-price">${price_html}</div>`;

  return price_html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_enable') &&
    boostPFSThemeConfig.custom.sold_out_enable && soldOut) {
    soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  var salePercent = '';
  // boostPFSThemeConfig.custom.sale_label_enable && onSale && !soldOut
  if (boostPFSThemeConfig.custom.sale_label_enable && onSale) {
    if (boostPFSThemeConfig.custom.sale_label_display == 'sale_percent'){
      salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
    }
    saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
    saleLabel = boostPFSTemplate.saleLabelHtml.replace(/percent/g, '-' + salePercent + '%');
  }
  // Build Labels
  // return soldOutLabel + saleLabel;
  return saleLabel;
}

// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (boostPFSThemeConfig.custom.tag_label_enable) {
    if (showall) {
      var tagLabel = '';
      if (data.tags) {
        for (var i = 0; i < data.tags.length; i++) {
          var tag = data.tags[i];
          if (tag.indexOf("badge") !== -1) {
            var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('badge:')[1]);
            tagLabel += preTagLabel;
          }
        }
      }
    } else {
      if (data.tags) {
        var tagLabel = '';
        if (data.tags.includes('badge:best-seller')) {
          tagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'Best Seller');
        } else if (data.tags.includes('badge:new')) {
          tagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'New');
        } else if (data.tags.includes('badge:limited-edition')) {
          tagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'Limited Edition');
        }

      }

      // if (data.tags) {
      //   for (var i = data.tags.length - 1; i >= 0; i--) {
      //     tag = data.tags[i];
      //     if (tag.indexOf("badge") !== -1) {
      //       var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('badge:')[1]);
      //       tagLabel += preTagLabel;
      //       break;
      //     }
      //   }
      // }
    }
    return tagLabel;
  } else {
    return "";
  }
}
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
// Build Color Swatches
function buildProductOptionSwatches(data) {
  const product = data;
  //console.log(data.title);
  const variants = product.variants;
  //console.log('variants: ', variants);
  const options = product.options;
  //console.log('options: ', options);
  var variant_html = '';

  if (variants.length > 1) {
    if (options.includes('color') || options.includes('size')) {
      // color html
      var color_option_index = 0;
      var size_option_index = -1;
      for (var i = 0; i < options.length; i++) {
        if (options[i] == 'color') {
          color_option_index = i;
        } else if (options[i] == 'size') {
          size_option_index = i;
        }
      }

      var selected_option = variants[0].option1;
        if (color_option_index == 0) {
          selected_option = variants[0].option1;
        } else if (color_option_index == 1) {
          selected_option = variants[0].option2;
        } else {
          selected_option = variants[0].option3;
        }
      var first_variant_option = selected_option;
      var variant_ids = [];
      variant_ids.push(variants[0].id);
      variants.forEach(variant => {
        var selected_option2 = variant.option1;
        if (color_option_index == 0) {
          selected_option2 = variant.option1;
        } else if (color_option_index == 1) {
          selected_option2 = variant.option2;
        } else {
          selected_option2 = variant.option3;
        }

        if (selected_option2 != first_variant_option) {
          variant_ids.push(variant.id);
          first_variant_option = selected_option2;
        }
      });

      var variant_count = 0;

      for(var i = 0; i < variants.length; i++) {
        if (variant_count >= 3) {
          break;
        }
        var swatch_color = '';
        if (color_option_index == 0) {
          swatch_color = variants[i].option1.toLowerCase();
        } else if (color_option_index == 1) {
          swatch_color = variants[i].option2.toLowerCase();
        } else {
          swatch_color = variants[i].option3.toLowerCase();
        }
        var stripped_space = swatch_color.replace(' ', '-');
        var stripped_dash = stripped_space.replace('/', '-');

        var disabled = ``;
        if (variants[i].inventory_quantity < 1) {
          disabled = 'color-swatch-disabled';
        }
        if (options.includes('color')) {
          if (variant_ids.includes(variants[i].id)) {
            variant_html += `<a href="/products/${product.handle}?variant=${variants[i].id}" class="boost-pfs-product-variant-single relative hover:shadow-label-hover color--swatch color-${stripped_dash} ${disabled}"><span class="hidden">Swatch color-${stripped_dash}</span></a>`
            variant_count += 1;
          }
        }
      }
      const color_array = [];
      for(var i = 0; i < variants.length; i++) {
        var swatch_color = '';
        if (color_option_index == 0) {
          swatch_color = variants[i].option1.toLowerCase();
        } else if (color_option_index == 1) {
          swatch_color = variants[i].option2.toLowerCase();
        } else {
          swatch_color = variants[i].option3.toLowerCase();
        }
        color_array.push(swatch_color);
      }
      const uniq_color_array = [...new Set(color_array)];
      //console.log('colors: ', uniq_color_array);

      var remainging_variants = 0;
      if (uniq_color_array.length > 3) {
        remainging_variants = uniq_color_array.length - 3;
      }

      if (remainging_variants > 0) {
        var temp_html = `colors`;
        if (remainging_variants == 1) {
          temp_html = `color`;
        }
        variant_html += `<div class="boost-pfs-product-remaining-variant-count">+${remainging_variants} ${temp_html}</div>`
      }

      // size html
      if (size_option_index != -1) {
        if (variant_html) {
          variant_html += '<div class="boost-pfs-product-color-size-options"> | </div>';
        }
        variant_html += `<div class="boost-pfs-product-size-options-wrapper">${product.options_with_values[size_option_index].values.length} sizes</div>`;
      }
      variant_html = `<div class="boost-pfs-filter-product-swatch-wrapper">${variant_html}</div>`;
    }
  }
  return variant_html;
}

// Build Color Swatches
function eventColorSwatches(event) {
  jQ('.boost-pfs-filter-item-swatch li span').each(function() {
    var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
    if (event == 'hover') {
      jQ(this).hover(function() {
        var newImage = jQ(this).data('img');
        img.attr('srcset', newImage);
      });
    }
    if (event == 'click') {
      jQ(this).click(function() {
        var newImage = jQ(this).data('img');
        img.attr('srcset', newImage);
      });
    }
    jQ(this).focus(function() {
      if (jQ('body').hasClass('boost-pfs-ada')) {
        var newImage = jQ(this).data('img');
        img.attr('srcset', newImage);
      }
    });
  });
}

function buildReview(data) {
  var html = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
    boostPFSThemeConfig.custom.show_product_review == true) {
    html = '<div class="yotpo-widget-instance" data-yotpo-instance-id="441996" data-yotpo-product-id="{{itemId}}" data-yotpo-cart-product-id="{{itemId}}" data-yotpo-section-id="{{template.name}}"></div>';
  }
  return html;
}

function buildActiveSwapClass(data) {
  if (!Utils.isMobile() && images.length > 1 &&
    boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
    boostPFSThemeConfig.custom.active_image_swap == true) {
    return 'has-bc-swap-image';
  }
  return '';
}



/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
  if (!totalProduct) totalProduct = this.totalProduct;
  // Get page info
  var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
  var totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));
  if (!currentPage || isNaN(currentPage)) {
    currentPage = 1;
  }
  // If it has only one page, clear Pagination
  if (totalPage <= 1) {
    return '';
  }

  var paginationHtml = boostPFSTemplate.paginateHtml;
  // Build Previous
  var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
  previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
  paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
  // Build Next
  var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
  nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
  paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
  // Create page items array
  var beforeCurrentPageArr = [];
  for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
    beforeCurrentPageArr.unshift(iBefore);
  }
  if (currentPage - 4 > 0) {
    beforeCurrentPageArr.unshift('...');
  }
  if (currentPage - 4 >= 0) {
    beforeCurrentPageArr.unshift(1);
  }
  beforeCurrentPageArr.push(currentPage);
  var afterCurrentPageArr = [];
  for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
    afterCurrentPageArr.push(iAfter);
  }
  if (currentPage + 3 < totalPage) {
    afterCurrentPageArr.push('...');
  }
  if (currentPage + 3 <= totalPage) {
    afterCurrentPageArr.push(totalPage);
  }
  // Build page items
  var pageItemsHtml = '';
  var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
  for (var iPage = 0; iPage < pageArr.length; iPage++) {
    if (pageArr[iPage] == '...') {
      pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
    } else {
      pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
    }
    pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
    pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
  }
  paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
  return paginationHtml;
};

// Build Sorting
ProductSorting.prototype.compileTemplate = function() {
  var html = '';
  if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if (paramSort == k) {
          activeClass = 'boost-pfs-filter-sort-item-active';
        }
        sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
  }
  return html;
};

ProductSorting.prototype.render = function() {
  jQ(Selector.topSorting).html(this.compileTemplate());

  if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
    jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
  }

  var labelSort = '';
  var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
  var sortingList = Utils.getSortingList();
  if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
    labelSort = sortingList[paramSort];
  } else {
    labelSort = Labels.sorting_heading;
  }

  jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
}

// Build Sorting event
ProductSorting.prototype.bindEvents = function() {
  var _this = this;
  jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
    e.preventDefault();
    FilterApi.setParam('sort', jQ(this).data('sort'));
    FilterApi.setParam('page', 1);
    FilterApi.applyFilter('sort');
  });

  jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
    jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
  });

  jQ(Selector.filterTreeMobileButton).click(function() {
    jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
  });

  jQ(document).on('click', function (e) {
    if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
      jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
    }
  });
};
// For Toolbar - Build Display type
ProductDisplayType.prototype.compileTemplate = function() {

  var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
  if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
    if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
    } else {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
    }
  } else {
    if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
    } else {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
    }
  }

  itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

  return itemHtml;
};

function buildDisplayTitle(type, count) {
  if(type === '') return type;
  // Build title for list view
  if(type === 'list') {
    return Labels.listView || 'List view';
  }
  // Build title for grid view
  if(typeof count === 'undefined' || count === 0) return Labels.gridView || 'Grid view';
  return (Labels.gridViewColumns || 'Grid view {{ count }} Columns').replace(/{{ count }}/g, count);
}

var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
ProductDisplayType.prototype.render = function() {
  // Call the original function in our app lib.
  // We don't have to copy a very big function out here to modify.
  // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
  originalRenderProductDisplayType.call(this);

  // Do your custom code after the original function has run
  // Active current display type
  if (this.$element.length) {
    this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
    this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
    if (Utils.stripHtml(Globals.queryParams.display) == 'list') {
      this.$element.find(this.selector.productDisplayTypeList).addClass('active');
    } else if (Utils.stripHtml(Globals.queryParams.display) == 'grid') {
      if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
        this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
        var $parent = jQ(this).parent();
        var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
        var $activeClass = $cssNames[$cssNames.length - 1];
        var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];

        if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
            jQ(this).addClass('active');

            // jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
            // return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
            // }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
            if(jQ('.boost-pfs-filter-product-item').length > 0) {
              var arrClass = jQ('.boost-pfs-filter-product-item').attr('class').split(' ');
              var prevClass = '';
              for (var i = 0; i < arrClass.length; i++) {
                if(arrClass[i].match (/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                  prevClass = arrClass[i];
                  break;
                }
              }
              jQ('.boost-pfs-filter-product-item').removeClass(prevClass);
              jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);

              // jQ('.boost-pfs-filter-product-item').className = jQ('.boost-pfs-filter-product-item').className.replace(/(^|\s)boost-pfs-filter-grid-width-\S+/g , '');
              // jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
            }

        } else if(!$parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view').split('-')[1] == curentGridColumn) {
            jQ(this).addClass('active');
        }
      });

      } else {
        this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
      }
    }
  }
};

// Build Show Limit
ProductLimit.prototype.compileTemplate = function() {
  var html = '';
  if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

    var numberList = Settings.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k in sortingArr) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
    }
  }
  return html;
};
// Build Breadcrumb
Breadcrumb.prototype.compileTemplate = function(colData) {
  if (!colData) colData = this.collectionData;
  var breadcrumbItemsHtml = '';
  if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
    }
  }
  return breadcrumbItemsHtml
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
ProductList.prototype.afterRender = function(data) {
  if (!data) data = this.data;

  // Intergrate Yotpo Review with Boost PFS
  if (typeof Yotpo !== 'undefined') {
    var api = new Yotpo.API(yotpo);
    yotpoWidgetsContainer.initWidgets(false);
  }
};

// Build additional elements
Filter.prototype.afterRender = function(data) {
  if (!data) data = this.data;
  var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
  }
  if (data.total_product == 0) {
    jQ(".boost-pfs-filter-default-toolbar-inner").addClass('boost-pfs-filter-toolbar-product-0');
  } else {
    jQ(".boost-pfs-filter-default-toolbar-inner").removeClass('boost-pfs-filter-toolbar-product-0');
  }
  jQ('.boost-pfs-filter-total-product').html(totalProduct);

  jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS) {
    Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
      isScrolling = !1
    }).on("touchmove", function() {
      isScrolling = !0
    }).on("touchend", function() {
      isScrolling || (window.location = jQ(this).attr("href"))
    });
  }
  // Load more widget
  var products_per_page = boostPFSFilterConfig.general.products_per_page;
  var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
  var totalPage = Math.ceil(data.total_product / Utils.stripHtml(Globals.queryParams.limit));
  if (!currentPage || isNaN(currentPage)) {
    currentPage = 1;
  }

  if (totalPage <= 1) {
    return '';
  }

  var product_counts = products_per_page;
  if (currentPage != totalPage) {
    product_counts = product_counts * currentPage;
  }

  jQ('.boost-pfs-filter-load-more-button').html('Load more');

  // Build Image Swap. Put this function here to impprove the pagespeed.
  swapImage(data);

  // Build Equal Height
  if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
    setTimeout(function(){
      equalHeight(data);
    }, 700);
  };

  jQ(window).resize(function() {
    if (Utils.stripHtml(Globals.queryParams.display) !== 'list') {
      setTimeout(function(){
        equalHeight(data);
      }, 700);
    }
  });

  // Build Event Color Swatch
  if (boostPFSThemeConfig.custom.swatch_change_img != 'none') {
    eventColorSwatches(boostPFSThemeConfig.custom.swatch_change_img);
  }

  if (typeof boostRemoveImageLoadingAnimation == 'function') {
    boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
  }

	// Layout Fullwidth Page
  if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
    jQ('body').addClass('boost-pfs-filter-fullwidth-page');
  }
  document.addEventListener('scroll', function() {
    if(jQ('.boost-pfs-filter-tree-h.boost-pfs-filter-stick').length > 0 && jQ(window).width() > 767){
      jQ('.boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
    }
  });

  // Fix confict Sticky Mobile theme Streamline
  if(jQ('.site-nav__thumb-menu').length > 0 && Utils.isMobile()){
    var heightHeaderThemeStick = jQ('.site-nav__thumb-menu').height() + 40;
    jQ('.boost-pfs-filter-tree-mobile-button-stick-wrapper').css('bottom',heightHeaderThemeStick).addClass('boost-pfs-filter-sticky-bottom');
    jQ('.boost-pfs-filter-mobile-style1').addClass('boost-pfs-filter-mobile-style1-sticky-bottom');
  }

  // Progres Indicator On Load More
  if (data.total_product > 0) {
    const indicatorWidth = product_counts / data.total_product * 100;
    let indicatorHTML = `
      <div class="boost-pfs-filter-load-more-indicator px-6">
        <div class="w-[400px] max-w-full mx-auto mb-8 bg-tan-2 h-2 rounded-lg">
          <div class="bg-tan-1 rounded-lg h-full" style="width: ${indicatorWidth}%;"></div>
        </div>
      </div>`;
    jQ('.boost-pfs-filter-load-more-total').after(indicatorHTML);
  }
};

function removeClassByPrefix(node, prefix) {
  var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
  node.className = node.className.replace(regx, '');
  return node;
}

var original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
ProductDisplayType.prototype._onClickEvent = function(event) {
  // Call the original function in our app lib.
  // We don't have to copy a very big function out here to modify.
  // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
  original_onClickEventProductDisplayType.call(this, event);

  // Do your custom code after the original function has run
  /*  View As Type 2/3/4/5/6 */

  if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
      jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
      var currentClass = jQ(event.target).data('view');
      jQ('.boost-pfs-filter-top-display-type')[0].className = jQ('.boost-pfs-filter-top-display-type')[0].className.replace(/(^|\s)grid-\S+/g , '');
      jQ('.boost-pfs-filter-top-display-type').addClass(currentClass);
  }
}

ProductListPlaceholder.prototype.render = function() {
  // Set limit number for product skeleton
  var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
  // Build placeholder items
  var placeholderItem = this.compileTemplate();
  this.$element = [];
  for (var i = 0; i < placeholderLimit; i++) {
    this.$element.push(jQ(placeholderItem));
  }
  // Show placeholder before send filter request OR hide it after get filter data
  if (!this.isFetchedProductData) {
    this.setShow();
  } else {
    this.setHide();
  }
}

ProductListPlaceholder.prototype.compileTemplateExtra = function() {
  //Todo: Build placeholder for List mode
  var template = boostPFSTemplate.productListPlaceholderHtml;
  var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
  var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
  /**
   * Set product class for product skeleton (to set column, style, etc.)
   * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
   */
  return template
    .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
    .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
    .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
    .replace(/{{paddingTop}}/g, imgRatio * 100)
}

/* Prevent conflict with theme vendor js */
Array.prototype.insert = function(a, b) {}

/* Math qual Height */
function equalHeight(data) {
  var equal_i = -1;
  var equal_els = [];
  var equal_element = null;

  // Equal Height Title
  jQ('.boost-pfs-filter-product-item').each(function(i, element) {

    var offsetTop = jQ(element).offset().top;
    if (!equal_element || equal_element.offset().top !== offsetTop) {
      equal_element = jQ(element);
      equal_i++;
    }

    if (!equal_els[equal_i]) {
      equal_els[equal_i] = [];
    }
    equal_els[equal_i].push(element);
  });

  for (var i = 0; i < equal_els.length; i++) {
    var max = 0;
    var maxRatio = 0;
    var iLength = equal_els[i].length;

    for (var j = 0; j < equal_els[i].length; j++) {
      var item = equal_els[i][j];
      var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
      max = Math.max(max, height);
    }
    jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });
  }

  var aspect_ratio = boostPFSFilterConfig.general.aspect_ratio;

  if (aspect_ratio != 'false') {
    var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

    var widthImage = jQ('.boost-pfs-filter-product-item').width();
    var indexData = 0;

    // For Ratio
    if (aspect_ratio != 'false' && aspect_ratio != 'auto') {
      var heightImage = 0;
      var widthImage = jQ('.boost-pfs-filter-product-item').width();
      if (aspect_ratio != 'false' && aspect_ratio != 'auto' && aspect_ratio != 'other') {
        var ratioWidthHeight = boostPFSThemeConfig.custom.aspect_ratio;
      } else {
        var ratioWidthHeight = '';
      }

      var ratioWidthHeightOther = boostPFSThemeConfig.custom.aspect_ratio_other;
      if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
        return null;
      } else {
        if (aspect_ratio != 'other') {
          ratioWidthHeight = ratioWidthHeight.split(':');
          ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
          heightImage = widthImage * ratioWidthHeight;
        } else if (ratioWidthHeightOther != '' && aspect_ratio == 'other') {
          ratioWidthHeightOther = ratioWidthHeightOther.split(':');
          ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
          heightImage = widthImage * ratioWidthHeightOther;
        }
      }
      jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);

    }
  }
}

// Swap Image
function swapImage(data) {
  if (!Utils.isMobile()) {
    if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true) {
      var dataSrcSetFlipImg = '',
        dataSrcFlipImg = '',
        flipImageAlt = '',
        dataSizes = 'auto',
        dataWidths = '',
        html = '';

      jQ(".boost-pfs-filter-product-item").each(function() {
        var productItemSelector = jQ(this);
        var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

        if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
          imgSelector.data('img-flip-src') != '') {
          dataSrcFlipImg = imgSelector.data('img-flip-src');
          dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
          flipImageAlt = imgSelector.attr('alt');
          dataWidths = imgSelector.data('widths');
          html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
            'data-srcset="' + dataSrcSetFlipImg + '" ' +
            'data-src="' + dataSrcFlipImg + '" ' +
            'data-widths="[' + dataWidths + ']" ' +
            'data-sizes="' + dataSizes + '" ' +
            'src="' + boostPFSImgDefaultSrc + '" ' +
            'alt="' + flipImageAlt + '" />';

          productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        }

      });
    }
  }
}

// Build Placeholder for the first load
function boostRemoveImageLoadingAnimation($selector) {
  if ($selector.length) {
    $selector.removeAttr('data-boost-image-loading-animation');
  }
}
/* Expand Filter */
jQ(document).ready(function() {

    jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
        jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
    });
    jQ('.boost-pfs-filter-custom-drawer-close').click(function(){
        jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
    });
    jQ('.boost-pfs-filter-custom-drawer-overlay').click(function(){
        jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
    });

    // Bind changing options with enter/space key for ADA
    jQ('.boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay').on('keydown', (event) => {
      if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
        jQ(event.target).click();
      }
    });

    // Fix issue header fix on the Parallax theme
    if(jQ('.mm-fixed-top').length > 0){
      var headerFixedHeight = jQ('.mm-fixed-top').height();
      jQ('.boost-pfs-filter-collection-header-wrapper').css('margin-top', headerFixedHeight);
    }

    jQ('body').on('click', '.boost-pfs-filter-option-category .boost-pfs-filter-option-item', (event) => {
      const h_ref = jQ(event.currentTarget).find('.boost-pfs-filter-button').attr('href');
      const temp_collection_handle = h_ref.split('/collections/')[1];
      const collection_handle = temp_collection_handle.split('?')[0];
      const c_info = collection_info[collection_handle];
      const c_title = c_info.c_title;
      const desc = c_info.desc;
      const c_image = c_info.c_image;
      const c_mobile_image = c_info.c_mobile_image;
      const c_enable_bg_overlay = c_info.c_enable_bg_overlay;
      const c_use_bg_color = c_info.c_use_bg_color;
      const text_class = c_info.text_class;

      var mobile_image = c_mobile_image;
      if (!mobile_image) {
        mobile_image = c_image
      }
      var desktop_image = c_image
      if (!desktop_image) {
        desktop_image = c_mobile_image
      }

      var overlay_html = ``
      if (c_enable_bg_overlay == "1") {
        overlay_html = `<div class="absolute left-0 top-0 w-full h-full z-[1] ${c_info.overlay}" style="opacity: 0.2"></div>`;
      }
      var bg_html = ``;
      if (c_use_bg_color == "1") {
        bg_html = `<div class="absolute left-0 top-0 w-full h-full ${c_info.bg_class}"></div>`
      } else {
        if (c_image || c_mobile_image) {
          var mobile_image = c_mobile_image ? c_mobile_image : c_image;
          var desktop_image = c_image ? c_image : c_mobile_image;
          var partial_bg_source = ``;
          if (c_image && c_mobile_image) {
            partial_bg_source = `<source data-srcset="${mobile_image}">`;
          }
          bg_html = `
            <picture>
              <source data-srcset="${desktop_image}"
                      media="(min-width: 1024px)" />
              ${partial_bg_source}
              <img src="${mobile_image}"
                  data-src="${mobile_image}"
                  class="lazyload absolute top-0 left-0 w-full h-full object-cover"
                  alt="collection" />
            </picture>`;
        } else {
          bg_html = `<div class="absolute left-0 top-0 w-full h-full ${c_info.bg_class}"></div>`;
        }
      }
      var header_wrapper = `
            ${overlay_html}
            ${bg_html}
          `;

      var desc_html = ``;
      if (desc) {
        var truncated_desc = desc.substring(0, 147);
        var full_desc = ``;
        if (desc.length > 150 ) {
          full_desc = `
          <a href="javascript:void(0);" class="focus-link !text-p-xxs tracking-086px" data-read-more-desc>Read more</a>
          <div class="full-description hidden" data-full-desc>
            ${desc}
          </div>
          <a href="javascript:void(0);" class="!hidden focus-link !text-p-xxs tracking-086px" data-read-less-desc>Read less</a>`
        }
        desc_html = `
          <div class="hidden lg:block bg-tan-3 collection-description-wrapper">
            <div class="max-w-[1173px] w-full mx-auto px-8 font-brandon text-p-s lg:text-p text-grey-1 collection-description-wrapper--inner pt-4 md:pt-0 pb-0 lg:pb-[68px] text-center" data-boost-pfs-desc-container>
              <div class="truncated-description">
                ${desc}
              </div>
            </div>
          </div>
          <div class="block lg:hidden bg-tan-3 collection-description-wrapper">
            <div class="max-w-[1173px] w-full mx-auto px-8 font-brandon text-p-s lg:text-p text-grey-1 collection-description-wrapper--inner pt-4 md:pt-0 pb-0 lg:pb-[68px] text-center" data-boost-pfs-desc-container>
              <div class="truncated-description" data-truncated-desc>
                ${truncated_desc}...
              </div>
              ${full_desc}
            </div>
          </div>
        `
      }
      setTimeout(() => {
        jQ('.boost-pfs-filter-collection-header-inner').html(header_wrapper);
        jQ('.boost-pfs-filter-collection-header').html(c_title);
        jQ('.boost-pfs-filter-collection-header').removeClass('text-white');
        jQ('.boost-pfs-filter-collection-header').removeClass('text-grey-1');
        jQ('.boost-pfs-filter-collection-header').addClass(text_class);
        jQ('.boost-pfs-filter-total-product').removeClass('text-white');
        jQ('.boost-pfs-filter-total-product').removeClass('text-grey-1');
        jQ('.boost-pfs-filter-total-product').addClass(text_class);

        jQ('.boost-pfs-collection-description-container').html(desc_html);
      }, 1000);
    })
    jQ('body').on('click', '[data-read-more-desc]', (event) => {
      jQ('[data-truncated-desc]').addClass('hidden');
      jQ('[data-truncated-desc]').removeClass('block');
      jQ('[data-full-desc]').addClass('block');
      jQ('[data-full-desc]').removeClass('hidden');
      jQ('[data-read-less-desc]').addClass('!inline-block');
      jQ('[data-read-less-desc]').removeClass('!hidden');
      jQ('[data-read-more-desc]').addClass('!hidden');
    })
    jQ('body').on('click', '[data-read-less-desc]', (event) => {
      jQ('[data-truncated-desc]').addClass('block');
      jQ('[data-truncated-desc]').removeClass('hidden');
      jQ('[data-full-desc]').addClass('hidden');
      jQ('[data-full-desc]').removeClass('block');
      jQ('[data-read-more-desc]').addClass('!inline-block');
      jQ('[data-read-more-desc]').removeClass('!hidden');
      jQ('[data-read-less-desc]').addClass('!hidden');
    })
});
})();
